import { Button } from "@chakra-ui/react";
import { TimelineLoader } from "applesauce-loaders/loaders";
import { useState } from "react";

export default function LoadMoreButton({ loader }: { loader?: TimelineLoader }) {
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  if (!loader || loaded) return null;

  const handleLoad = () => {
    setLoading(true);
    const sub = loader();
    sub.subscribe({
      complete: () => {
        setLoading(false);
        setLoaded(true);
      },
      error: () => setLoading(false),
    });
  };

  return (
    <Button
      onClick={handleLoad}
      isLoading={loading}
      flexShrink={0}
      size="xs"
      variant="ghost"
      color="gray.500"
      mx="auto"
      my="2"
    >
      Load older
    </Button>
  );
}
